import { render } from "./PartnersComponent.vue?vue&type=template&id=32d9e84b&scoped=true"
import script from "./PartnersComponent.vue?vue&type=script&lang=js"
export * from "./PartnersComponent.vue?vue&type=script&lang=js"

import "./PartnersComponent.vue?vue&type=style&index=0&id=32d9e84b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ahmed.shaker.KORABIA\\Desktop\\hesabtech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d9e84b"]])

export default __exports__